const BYTES_IN_KILOBYTE = 1024; 
const KILOBYTES_IN_MEGABYTE = 1024; 
const MAX_FILE_SIZE = 10 * KILOBYTES_IN_MEGABYTE; 
const MAX_FILE_SIZE_MB = MAX_FILE_SIZE / KILOBYTES_IN_MEGABYTE; 
export { BYTES_IN_KILOBYTE, KILOBYTES_IN_MEGABYTE, MAX_FILE_SIZE, MAX_FILE_SIZE_MB };
